<template>
  <div class="extractSupporter column">
    <h1>Extrato Supporter</h1>
    <div class="filters row column-s justify-space">
      <div class="grid-4 grid-12-s padding">
        <label>Supporter</label>
        <Supporters @value="(item) => (filter = { ...filter, id_doutor: item.id, }, this.sb = true)"
          :name="['id', 'nome']" />
      </div>
      <div class="grid-3 grid-12-s">
        <label>Status do Pagamento</label><br />
        <select v-model="filter.status_pagamento" class="input">
          <option value="">SELECIONE</option>
          <option value="pago">Pago</option>
          <option value="pendente">Pendente</option>
        </select>
      </div>
      <div class="grid-2 grid-12-s"><label>Encerramento Inicial</label><br /><input v-model="filter.data_inicio"
          type="date" />
      </div>
      <div class="grid-2 grid-12-s"><label>Encerramento Final</label><br /><input v-model="filter.data_fim"
          type="date" />
      </div>
      <Button v-if="sb" @click="send" layout="green-m" :loader="loader"><i class="fa fa-filter" />Gerar</Button>
    </div>
    <div v-if="list.length" class="container column">

      <div class="list">
        <div class="head sub row justify-space">
          <div class="grid-3">Previsão Pagamento</div>
          <div class="grid-2">Jobs</div>
          <div class="grid-2">Horas Adicionais</div>
          <div class="grid-2">Reembolso</div>
          <div class="grid-2">Total</div>
        </div>
        <div class="line grid-12" v-for="(e, i) of list" :key="'e' + i">
          <div class="row align-center grid-12 justify-space" @click="list[i].show = !list[i].show; list = [...list]"
            style="padding: 4px 0">
            <div class="grid-3">{{ e.dt_previsao_pagamento | date }}</div>
            <div class="grid-2">{{ e.total_atendimento_ciclo | money }}</div>
            <div class="grid-2">{{ e.total_horas_extras_ciclo | money }}</div>
            <div class="grid-2">{{ e.total_reembolso_ciclo | money }}</div>
            <div class="grid-2">{{ e.total_geral_ciclo | money }}</div>
          </div>
          <template v-if="e.show">
            <div class="detail" v-for="(r, j) of e.jobs" :key="'j' + j">
              <div class="sub row justify-space">
                <div class="grid-1">ID</div>
                <div class="grid-2">Tipo Serviço</div>
                <div class="grid-2">Encerramento </div>
                <div class="grid-1">Job</div>
                <div class="grid-1">Horas Adicionais</div>
                <div class="grid-1">Reembolso</div>
                <div class="grid-1">Total</div>
                <div class="grid-2"></div>
              </div>
              <div class="li row justify-space">
                <div class="grid-1">{{ r.id_job }}</div>
                <div class="grid-2">{{ r.tipo_servico }}</div>
                <div class="grid-2">{{ r.dh_ult_encerramento | date }}</div>
                <div class="grid-1">{{ r.total_atendimento_job | money }}</div>
                <div class="grid-1">{{ r.total_horas_extras_job | money }}</div>
                <div class="grid-1">{{ r.total_reembolso_job | money }}</div>
                <div class="grid-1">{{ r.total_geral_job | money }}</div>
                <div class="grid-2 text-right"><a :href="`/funcionario/job/${r.id_job}`" target="_blank">VER</a></div>

              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Supporters from "@/components/select/Supporters";

export default {
  name: "ExtractSupporter",
  components: {
    Button,
    Supporters
  },
  data() {
    return {
      loader: false,
      sb: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      filter: {
        data_inicio: "",
        data_fim: "",
        id_doutor: 0,
        status_pagamento: ""
      },
      list: [],
    };
  },
  methods: {
    ...mapActions("admin", ["EXTRACT_SUPPORTER"]),
    async send() {
      this.loader = true;
      await this.EXTRACT_SUPPORTER(this.filter)
        .then(({ data }) => (this.list = data || []))
      this.loader = false;
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("extractSupporter");
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.extractSupporter
  @include page
  .filters
    margin-top: 8px
    @media(max-width: $small)
      padding: 12px
    .supporters, .input, input[type="date"]
      margin-top: 4px
      width: 80%
      min-width: 140px
      @media(max-width: $small)
        min-width: 90%
        margin-bottom: 20px 
    .supporters
      width: 90%
    button
      margin-top: 20px
      @media(max-width: $small)
        margin: 0
        width: 90%
  .container
    margin-top: 35px
    overflow: auto
  .list
    margin-top: -10px
    background: white
    max-height: 400px
    padding: 20px
    min-width: 800px
    @media(max-width: $small)
      margin: 0
    .head
      margin-bottom: 0
      font-size: 15px
    .line
      font-size: 16px
      padding: 10px 0
      &:hover
        background: $purple
        cursor: pointer
        color: white
        border-radius: 5px
        .detail
          color: $font-color
        .sub
          color: $purple
    .detail
      border-radius: 4px
      background: #f1f1f1
      padding: 10px 20px
      margin-top: 1px
      &:hover
        background: rgba(white, .8)     
      .sub
        margin-bottom: 4px
      .li
        a
          background: $purple
          color: white
          padding: 6px 12px
          border-radius: 5px
          font-weight: bold
          font-size: 13px
</style>
